<template lang="pug">
div.home(:style="`background-image: url(${imgBackgroundHome});`")
  v-container.fill-height(fluid)
    v-row.home-message(align="end" justify="center" no-gutters)
      v-col(cols=12)
        v-row.pb-8
          v-col
            v-divider
        v-row(:justify="isMobile ? 'center' : 'start'" align="center" no-gutters)
          v-col(cols="auto")
            span.footer-text Copyright © {{ currentYear }}
        template(v-if="isMobile")
          v-row(align="center" justify="center")
            v-col(cols="auto")
              span.footer-text {{ homeMessage }}
          v-row.pb-10(align="center" justify="center")
            v-col(cols="auto")
              span.footer-text Termos e Políticas | Versão {{ version }}
        template(v-else)    
          v-row(align="center" justify="center" no-gutters)  
              v-col
                span.footer-text {{ homeMessage }}
              v-col.d-flex.flex-row.justify-end
                span.footer-text Versão {{ version }}
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { HOME_MESSAGE } from "@/env.js";

export default {
  name: "HomeBackground",
  data() {
    return { currentYear: new Date().getFullYear() };
  },
  computed: {
    ...mapFields("assets", ["savedImgBackgroundHome", "backgroundLoaded"]),
    version() {
      return process.env.PACKAGE_VERSION;
    },
  },
  watch: {
    savedImgBackgroundHome: {
      handler() {
        this.showImgBackground();
      },
    },
  },
  created() {
    this.showImgBackground();
    this.homeMessage =
      process.env.NODE_ENV === "production"
        ? HOME_MESSAGE
        : process.env.VUE_APP_HOME_MESSAGE;
  },
  methods: {
    showImgBackground() {
      if (this.savedImgBackgroundHome !== null) {
        this.imgBackgroundHome = this.savedImgBackgroundHome;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.footer-text
  color: var(--v-homeFooterText-base)

.container
  align-items: end !important
  height: 100%
  width: 100%
  padding: 0
  margin: 0

.padding-logo
  padding: 5%

.home-message
  padding-left: 100px
  padding-right: 80px
  margin-bottom: 20px

.home
  min-height: 400px
  height: 100%
  width: 100%
  background: var(--v-primary-base)
  background-repeat: no-repeat
  background-position: center
  background-size: 500px

@media #{map-get($display-breakpoints, 'xs-only')}
  .logo
    max-width: 60%
    object-fit: cover
  .padding-logo
    padding-top: 40%
  .home
    background-size: 60%
</style>
